import React from 'react';
import PropTypes from 'prop-types';
import { Icon, T } from 'components/misc';
import Smiley from './EmojiCategoryIcons/Smiley';
import Burger from './EmojiCategoryIcons/Burger';
import Flag from './EmojiCategoryIcons/Flag';
import Football from './EmojiCategoryIcons/Football';
import Leaf from './EmojiCategoryIcons/Leaf';
import Lightbulb from './EmojiCategoryIcons/Lightbulb';
import PeaceSign from './EmojiCategoryIcons/PeaceSign';
import Plane from './EmojiCategoryIcons/Plane';

import {
  SMILEYS_AND_PEOPLE,
  ANIMALS_AND_NATURE,
  FOOD_AND_DRINK,
  TRAVEL_AND_PLACES,
  ACTIVITIES,
  OBJECTS,
  SYMBOLS,
  FLAGS,
} from './Emojis';

class ItemPicker extends React.Component {
  state = {
    showPicker: false,
    style: {
      overflow: 'hidden',
    },
    emojiType: 'Smileys & People',
  };

  _content = React.createRef()
  componentDidMount() {
    window.addEventListener('click', this.onWindowClick, false);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick, false);
  }

  onWindowClick = e => {
    if (
      this.state.showPicker &&
      !document
        .querySelector(`.chat-${this.props.type}-picker`)
        .contains(e.target)
    ) {
      this.togglePicker()
    }
  };

  emojiTypeSelect = type => {
    this.setState({ emojiType: type });
  };

  togglePicker = () => {
    this.setState({
      showPicker: !this.state.showPicker,
      style: { overflow: 'auto' },
    });
    const element = this._content.current
    if (element) {
      element.scrollTop = 0
    }
  };

  render() {
    const { label, icon, type } = this.props;
    const isOpen = this.state.showPicker;
    const renderPicker = type === 'emoji' ? this.renderEmojiPicker() : this.renderStickers()
    return (
      <div
        className={`chat-item-picker chat-${type}-picker chat-item-picker-${
          isOpen ? 'open' : 'closed'
        }`}
      >
        <div className="chat-item-picker-toggle" onClick={this.togglePicker}>
          {icon && (
              <Icon
                iconName={isOpen ? 'arrowDown' : icon}
                className="chat-ui-icon_circle"
              />
          )}
          {label && <T>{label}</T>}
        </div>
        <div className="item-dropdown">
          {renderPicker}
        </div>
      </div>
    );
  }

  onSelect = e => {
    const alt = e.target.getAttribute('alt');
    if (alt !== undefined) {
      this.props.onSelect(alt);
      this.setState({ showPicker: false });
    }
  };

  renderStickers() {
    const {type, Item, items } = this.props;
    return (
      <div className="item-content" style={this.state.style} ref={this._content}>
        {items.map((key, index) => (
        Array.isArray(key)
        ? <div key={index} className={`group group-${key[0]}`}>{key.map((e, i) => <Item name={e} key={i} className={type} onClick={this.onSelect}/>)}</div>
        : <Item name={key} key={index} className={type} onClick={this.onSelect}/>
      ))}
    </div>
    )
  }

  renderEmojiPicker() {
    const {type, Item } = this.props;

    let emojiArray = SMILEYS_AND_PEOPLE;
    switch (this.state.emojiType) {
      case 'Smileys & People':
        emojiArray = SMILEYS_AND_PEOPLE;
        break;
      case 'Animals & Nature':
        emojiArray = ANIMALS_AND_NATURE;
        break;
      case 'Food & Drink':
        emojiArray = FOOD_AND_DRINK;
        break;
      case 'Travel & Places':
        emojiArray = TRAVEL_AND_PLACES;
        break;
      case 'Activities':
        emojiArray = ACTIVITIES;
        break;
      case 'Objects':
        emojiArray = OBJECTS;
        break;
      case 'Symbols':
        emojiArray = SYMBOLS;
        break;
      case 'Flags':
        emojiArray = FLAGS;
        break;
      default:
        emojiArray = SMILEYS_AND_PEOPLE;
        break;
    }

    return (
      this.state.showPicker && (
        <div
          className="emoji-wrapper"
          style={type == 'emoji' ? {} : this.state.style}
          ref={this._content}
        >
          <>
            <div className="emoji-category">
              <span
                className="emoji-category-single"
                onClick={() => this.emojiTypeSelect('Smileys & People')}
              >
                <Smiley
                  isClicked={this.state.emojiType == 'Smileys & People'}
                />
              </span>
              <span
                className="emoji-category-single"
                onClick={() => this.emojiTypeSelect('Animals & Nature')}
              >
                <Leaf isClicked={this.state.emojiType == 'Animals & Nature'}/>
              </span>
              <span
                className="emoji-category-single"
                onClick={() => this.emojiTypeSelect('Food & Drink')}
              >
                <Burger isClicked={this.state.emojiType == 'Food & Drink'}/>
              </span>
              <span
                className="emoji-category-single"
                onClick={() => this.emojiTypeSelect('Travel & Places')}
              >
                <Plane isClicked={this.state.emojiType == 'Travel & Places'}/>
              </span>
              <span
                className="emoji-category-single"
                onClick={() => this.emojiTypeSelect('Activities')}
              >
                <Football isClicked={this.state.emojiType == 'Activities'}/>
              </span>
              <span
                className="emoji-category-single"
                onClick={() => this.emojiTypeSelect('Objects')}
              >
                <Lightbulb isClicked={this.state.emojiType == 'Objects'}/>
              </span>
              <span
                className="emoji-category-single"
                onClick={() => this.emojiTypeSelect('Symbols')}
              >
                <PeaceSign isClicked={this.state.emojiType == 'Symbols'}/>
              </span>
              <span
                className="emoji-category-single"
                onClick={() => this.emojiTypeSelect('Flags')}
              >
                <Flag isClicked={this.state.emojiType == 'Flags'}/>
              </span>
            </div>
            <div className="emoji-header">{this.state.emojiType}</div>
            <div className="emoji-item-content">
              {emojiArray.map((key, index) =>
                Array.isArray(key) ? (
                  <div key={index} className={`group group-${key[0]}`}>
                    {key.map((e, i) => (
                      <Item
                        name={e}
                        key={i}
                        className={type}
                        onClick={this.onSelect}
                      />
                    ))}
                  </div>
                ) : (
                  <Item
                    name={key}
                    key={index}
                    className={type}
                    onClick={this.onSelect}
                  />
                )
              )}
            </div>
          </>
        </div>
      )
    );
  }
}

ItemPicker.propTypes = {
  onSelect: PropTypes.func.isRequired,
};

export default ItemPicker;
